<template>
    <div>
        <div class="bg-overlay"></div>
        <div class="account-pages my-5 pt-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-md-8">
                        <div class="card">
                            <div class="card-body p-4">
                                <div class="">
                                    <h4 class="font-size-18 text-muted mt-2 text-center">TATA HIJAU ASRI</h4>
                                    <p class="mb-2 text-center">Login to continue to app</p>
                                    <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Username </label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-user-bold"></i>
                                                        <input type="text"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.username.$error }" v-model="username" placeholder="Enter username...">
                                                            <div v-if="submitted && !$v.username.required" class="invalid-feedback">Username is required</div>    
                                                    </div>
                                                </div>
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Password </label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-lock-bold"></i>
                                                        <input type="password"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.password.$error }" v-model="password" placeholder="Enter Password...">
                                                            <div v-if="submitted && !$v.password.required" class="invalid-feedback">Password is required</div>
                                                    </div>
                                                </div>

                                                <div class="d-grid mt-4">
                                                    <button :disabled="waiting" type="submit" class="btn btn-primary waves-effect waves-light">
                                                        {{ waiting ? 'Please wait...' : 'Login' }}                                                
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end row -->
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";

    export default {
        name: 'Signin',
        metaInfo: {
            title: 'Signin',
            titleTemplate: '%s - Tata Hijau Asri'
        },
        data() {
            return {
                username: "",
                password: "",
                submitted: false,
                waiting: false,
            }
        },
        mounted () {
            document.body.classList.add('bg-pattern')
        },
        validations: {
            username: {
                required
            },
            password: {
                required
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting = true;
                this.submitted = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please complete the form',
                    });

                    this.waiting = false;
                    return;
                } else {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'auth/signin', {
                            username: this.username,
                            password: this.password
                        })
                        .then(response => {
                            this.waiting = false;

                            if (response.data.status) {
                                const token = response.data.user.key;
                                localStorage.setItem('auth_token', token);
                                location.reload();
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                        })
                }
            }
        }
    }
</script>